export const isMobile =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )
export const isAndroid = /Android/i.test(navigator.userAgent)
export const isImToken = !!window.imToken || window?.ethereum?.isImToken
export const isMetamask = typeof window.ethereum !== 'undefined'
export const isValoraAndroid = isAndroid && !isImToken && !isMetamask
